import LocalizedString from '@/types/localized-string';
import { LotWithTaxMetrics } from '@capintel/instruments-lib';

export interface HoldingWithTaxData {
  _id: string;
  ticker?: string;
  name?: LocalizedString;
  purchaseDate?: Date | string;
  units?: number;
  costBasis?: number;
  marketValue?: number;
  shortTermUnrealizedGainLoss?: number;
  longTermUnrealizedGainLoss?: number;
  totalUnrealizedGainsLoss?: number;
  currentAllocation?: number;
  comparisonItemId: string;
  // Target portfolio fields (when comparing to a target)
  valueChange?: number; // Dollar value change (Target Dollar Value - Current Dollar Value)
  estimatedRealizedGainLoss?: number;
  taxCostToReachTarget?: number;
  // Lots data for expandable sub-rows
  lots?: LotWithTaxMetrics[];
}

export enum TaxAnalysisTableKeys {
  Ticker = 'ticker',
  Name = 'name',
  Units = 'units',
  PurchaseDate = 'purchaseDate',
  CostBasis = 'costBasis',
  MarketValue = 'marketValue',
  ShortTermUnrealizedGainLoss = 'shortTermUnrealizedGainLoss',
  LongTermUnrealizedGainLoss = 'longTermUnrealizedGainLoss',
  TotalUnrealizedGainsLoss = 'totalUnrealizedGainsLoss',
  CurrentAllocation = 'currentAllocation',
  // Target portfolio columns
  ValueChange = 'valueChange',
  EstimatedRealizedGainLoss = 'estimatedRealizedGainLoss',
  TaxCostToReachTarget = 'taxCostToReachTarget',
}

export enum RowType {
  Total = 'total',
}

export type TaxAnalysisRow = {
  [TaxAnalysisTableKeys.Ticker]: string;
  [TaxAnalysisTableKeys.Name]: string;
  [TaxAnalysisTableKeys.PurchaseDate]: string;
  [TaxAnalysisTableKeys.Units]: number;
  [TaxAnalysisTableKeys.CostBasis]: number;
  [TaxAnalysisTableKeys.MarketValue]: number;
  [TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss]: number;
  [TaxAnalysisTableKeys.LongTermUnrealizedGainLoss]: number;
  [TaxAnalysisTableKeys.TotalUnrealizedGainsLoss]: number;
};
